import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BlogList from "../components/BlogList";

const BlogListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title='Blogs List' />

        <BlogList />

      </MasterLayout>
    </>
  );
};

export default BlogListPage;
